export const copyToClipBoard = (text: string) => {
    var textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    textField.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(textField.value);
    textField.remove();
}